define('../app/fukit/behavior/enable.only.on.unsaved.changes.behavior',['require','underscore','./base.unsaved.changes.behavior'],function(require) {
  //prettier-ignore
  var _                          = require('underscore'),
      BaseUnsavedChangesBehavior = require('./base.unsaved.changes.behavior');

  // Example Require:
  // var EnableOnlyOnUnsavedChangesBehavior = require('./enable.only.on.unsaved.changes.behavior');
  //
  // Example Usage:
  // EnableOnlyOnUnsavedChanges: {
  //  model: this.model,
  //  behaviorClass: EnableOnlyOnUnsavedChangesBehavior
  // }

  var EnableOnlyOnUnsavedChangesBehavior = BaseUnsavedChangesBehavior.extend({
    defaults: _.extend({}, BaseUnsavedChangesBehavior.prototype.defaults, {
      // should the enabling effect be inverted (i.e. disable on unsaved changes)
      invert: false,
    }),

    onInitializeUnsavedChanges: function() {
      this.evaluateViewDisabled();
    },

    onUnsavedChanges: function() {
      this.evaluateViewDisabled();
    },

    evaluateViewDisabled: function() {
      if (this.unsavedChangesExist()) {
        this.view.hasUnsavedChanges = true;
        this.view.disabled = this.getOption('invert') ? true : false;
      } else {
        this.view.hasUnsavedChanges = false;
        this.view.disabled = this.getOption('invert') ? false : true;
      }
    },
  });
  return EnableOnlyOnUnsavedChangesBehavior;
});

